import { useEffect, useRef, useState } from 'react';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { InlineLabels } from './InlineLabels';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportSettingsLabel = ({
  asyncEnhancedReport,
  overrideTooltip,
  isMobile,
  customSubheader,
  inlineLabelTypes,
  reportResolveData,
  useInlineLabels = true
}) => {
  // Asserts updatedReport is not undefined as AsyncData.data is optional;
  const updatedReport = asyncEnhancedReport.data;
  const containerRef = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  useEffect(() => {
    const activeNode = containerRef.current;
    const handleResize = entries => {
      for (const entry of entries) {
        if (entry.target === activeNode) {
          setLabelWidth(entry.contentRect.width);
        }
      }
    };
    const resizeObserver = new ResizeObserver(handleResize);
    if (activeNode) {
      resizeObserver.observe(activeNode);
    }

    // Cleanup the observer on unmount
    return () => {
      if (resizeObserver && activeNode) {
        resizeObserver.unobserve(activeNode);
      }
    };
  }, []);
  const config = isConfigReport(updatedReport) ? updatedReport.get('config') : undefined;
  return /*#__PURE__*/_jsx(InlineLabels, {
    config: config,
    containerWidth: labelWidth,
    overrideTooltip: overrideTooltip,
    isMobile: isMobile,
    inlineLabelTypes: inlineLabelTypes,
    customSubheader: customSubheader,
    reportResolveData: reportResolveData,
    report: updatedReport,
    useInlineLabels: useInlineLabels
  });
};
export default ReportSettingsLabel;